import {
    useMemo,
} from 'react'
import clsx from 'clsx'

import injectClass from 'app/utils/injectClass'
import {
    ContainerNoteType,
} from 'app/enums/label.enums'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'

import getFields from './ContainerNoteDetails.fields'
import getClassNames from './utils/getClassNameByNoteType'
import useStyles from './ContainerNoteDetails.styles'

type Props = {
    name: string,
    data: {
        noteText: string,
        noteType: ContainerNoteType,
    },
}

export const ContainerNoteDetails = ({
    name,
    data,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()

    const modifiedNote = useMemo(() => {
        const modifiedNoteText = data.noteText?.includes('\n')
            ? data.noteText.split('\n').map((item) => {
                return (
                    <span key={`noteText-${item}`}>
                        {item}
                        <br />
                    </span>
                )
            }) : data.noteText

        return {
            ...data,
            noteText: modifiedNoteText,
        }
    }, [data])

    const {
        gridWrapper, gridAreaTemplate, ...restClasses
    } = getClassNames(data.noteType, classes)

    return (
        <div className={classes.rowFormContainer}>
            <DomainObjectForm
                name={name}
                className={clsx(
                    gridWrapper, gridAreaTemplate,
                )}
                classNames={restClasses}
                value={modifiedNote}
                fields={
                    injectClass(getFields(data.noteType), classes)
                }
                exists
                disabled
            />
        </div>
    )
}

export default ContainerNoteDetails
